/* Secure Measures OS 2.0 rebuild — behaviour upgrades.
   Loaded after functions.js. Replaces the original jQuery top-animation for the drawer menu with a
   class toggle (the slide itself is a CSS transform in upgrades.css), adds a scroll lock while the
   drawer is open, closes on Escape / backdrop click / resize to desktop, and keeps the original
   search-box behaviour untouched. */
jQuery(function ($) {
  var $trigger = $('#mobileTrigger');
  var $nav = $('header#head #mainMenu');
  if (!$trigger.length || !$nav.length) return;

  var DESKTOP = 1336; // matches the theme's own header breakpoint in style.css
  var html = document.documentElement;

  // detach the original handler (it animated `top` and toggled display)
  $trigger.off('click');
  $nav.attr('style', function (i, s) { return (s || '').replace(/(top|display)\s*:[^;]+;?/g, ''); });

  function isOpen() { return $nav.hasClass('is-open'); }
  function open() {
    $nav.addClass('is-open');
    $trigger.addClass('opened').attr('aria-expanded', 'true');
    html.classList.add('menu-open');
    $nav.find('a').first().trigger('focus');
  }
  function close() {
    $nav.removeClass('is-open');
    $trigger.removeClass('opened').attr('aria-expanded', 'false');
    html.classList.remove('menu-open');
  }
  function toggle() { isOpen() ? close() : open(); }

  $trigger.attr({ role: 'button', tabindex: '0', 'aria-label': 'Menu', 'aria-controls': 'mainMenu', 'aria-expanded': 'false' });
  $trigger.on('click', function (e) { e.preventDefault(); toggle(); });
  $trigger.on('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  $(document).on('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
  // tap on the tinted backdrop (outside the menu content) closes the drawer
  $nav.on('click', function (e) { if (e.target === this || $(e.target).is('.scroll')) close(); });
  $(window).on('resize', function () { if (window.innerWidth >= DESKTOP && isOpen()) close(); });
});

/* Session (date) selector — see snippets/session-selector.liquid.
   Hides past dates, marks or hides sold-out ones, keeps the add-to-cart form, price, seat count and
   date in step with the chosen session, and disables the button when nothing can be booked. */
(function () {
  var DATE_RE = /^[A-Za-z]{3},\s+([A-Za-z]{3})\s+(\d{1,2}),\s+(\d{4})(?:\s+(\d{1,2}):(\d{2})\s*(AM|PM))?/i;
  var MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };

  function parseSession(title) {
    var m = DATE_RE.exec(title || '');
    if (!m) return null;
    var month = MONTHS[m[1].toLowerCase()];
    if (month === undefined) return null;
    var hour = m[4] ? parseInt(m[4], 10) % 12 : 0;
    if (m[6] && m[6].toUpperCase() === 'PM') hour += 12;
    return new Date(parseInt(m[3], 10), month, parseInt(m[2], 10), hour, m[5] ? parseInt(m[5], 10) : 0);
  }

  function init(wrap) {
    var select = wrap.querySelector('select');
    var form = document.getElementById(wrap.getAttribute('data-form'));
    if (!select || !form) return;
    var hidePast = wrap.getAttribute('data-hide-past') === 'true';
    var soldoutMode = wrap.getAttribute('data-soldout-mode') || 'disable';
    var soldoutText = wrap.getAttribute('data-soldout-text') || '';
    var button = form.querySelector('button[type="submit"], button[name="add"]');
    var scope = wrap.closest('section') || document;
    var price = scope.querySelector('[data-sm-price]');
    var now = Date.now();

    Array.prototype.slice.call(select.options).forEach(function (opt) {
      var when = parseSession(opt.getAttribute('data-title'));
      var isPast = when !== null && when.getTime() < now;
      var isAvail = opt.getAttribute('data-avail') === 'true';
      if (isPast && hidePast) { opt.remove(); return; }
      if (!isAvail) {
        if (soldoutMode === 'hide') { opt.remove(); return; }
        opt.disabled = true;
        if (soldoutText) opt.textContent = opt.textContent + ' · ' + soldoutText;
      }
    });

    var first = null;
    for (var i = 0; i < select.options.length; i++) { if (!select.options[i].disabled) { first = select.options[i]; break; } }
    var empty = wrap.querySelector('.sm-sessions__empty');

    function sync() {
      var opt = select.options[select.selectedIndex];
      var bookable = !!opt && !opt.disabled;
      if (button) button.disabled = !bookable;
      if (!opt) return;
      if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
      var qty = opt.getAttribute('data-qty');
      Array.prototype.forEach.call(document.querySelectorAll('[data-sm-seats]'), function (el) { el.textContent = qty; });
      Array.prototype.forEach.call(document.querySelectorAll('[data-sm-date]'), function (el) { el.textContent = opt.getAttribute('data-title'); });
    }

    if (!first) {
      select.hidden = true;
      var label = wrap.querySelector('.sm-sessions__label');
      if (label) label.hidden = true;
      if (empty) empty.hidden = false;
      if (button) button.disabled = true;
      return;
    }
    select.value = first.value;
    select.addEventListener('change', sync);
    sync();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-sm-sessions]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
